// Избранное на стороне покупателя: список handle'ов в localStorage.
// Доступ к хранилищу обёрнут в try/catch — в приватном окне он может бросать.
(function () {
  const KEY = 'artmellio:wishlist';

  const read = () => {
    try {
      const raw = localStorage.getItem(KEY);
      const list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  };

  const write = (list) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* приватный режим — избранное просто не сохранится */
    }
  };

  const broadcast = () => document.dispatchEvent(new CustomEvent('wishlist:change', { detail: read() }));

  window.ArtmellioWishlist = {
    all: read,
    has: (handle) => read().includes(handle),
    toggle(handle) {
      const list = read();
      const i = list.indexOf(handle);
      if (i === -1) list.push(handle);
      else list.splice(i, 1);
      write(list);
      broadcast();
      return i === -1;
    },
    remove(handle) {
      write(read().filter((h) => h !== handle));
      broadcast();
    },
  };

  class WishlistButton extends HTMLElement {
    connectedCallback() {
      this.handle = this.dataset.handle;
      this.control = this.querySelector('.wishlist-button__control');
      if (!this.control || !this.handle) return;

      this.sync();
      this.control.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        window.ArtmellioWishlist.toggle(this.handle);
      });

      this.onChange = () => this.sync();
      document.addEventListener('wishlist:change', this.onChange);
    }

    disconnectedCallback() {
      document.removeEventListener('wishlist:change', this.onChange);
    }

    sync() {
      const saved = window.ArtmellioWishlist.has(this.handle);
      this.classList.toggle('is-saved', saved);
      this.control.setAttribute('aria-pressed', saved ? 'true' : 'false');
    }
  }

  if (!customElements.get('wishlist-button')) customElements.define('wishlist-button', WishlistButton);

  // счётчик рядом со ссылкой в меню, если она есть
  const paintCount = () => {
    const n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = n ? ` (${n})` : '';
    });
  };
  document.addEventListener('wishlist:change', paintCount);
  document.addEventListener('DOMContentLoaded', paintCount);
})();
